import React from 'react';
import { Star } from 'lucide-react';
export function TrustStrip() {
  return <div className="w-full bg-[#1a1a1a] py-5 border-y border-white/5" data-id="element-148">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-center items-center gap-3" data-id="element-149">
        <div className="flex space-x-1" data-id="element-150">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-amber fill-amber" data-id="element-151" />)}
        </div>
        <span className="text-muted text-sm tracking-wide uppercase font-medium text-center" data-id="element-152">
          Trusted by 5,000+ Dedicated Dog Owners
        </span>
      </div>
    </div>;
}